import { render, staticRenderFns } from "./GoogleDriveChannels.vue?vue&type=template&id=00978df1&scoped=true"
import script from "./GoogleDriveChannels.vue?vue&type=script&lang=js"
export * from "./GoogleDriveChannels.vue?vue&type=script&lang=js"
import style0 from "./GoogleDriveChannels.vue?vue&type=style&index=0&id=00978df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00978df1",
  null
  
)

export default component.exports